import getUnixTimestamp from './getUnixTimestamp';
import utcToZonedDate from './utcToZonedDate';
import getDateFromUnixTime from './getDateFromUnixTime';

/**
 * @deprecated This helper is deprecated. Use the @dealroadshow/uikit-date-time class with appropriate methods instead.
 */
const setLocalZone = (timeZone: string, timestamp: number) => {
  if (!timestamp) {
    return null;
  }

  return getUnixTimestamp(utcToZonedDate(timeZone, getDateFromUnixTime(timestamp)));
};

export default setLocalZone;
